// libs
import * as React from 'react'

// classes / components
import Notification, { clsHighlightedText, clsText, NotificationProps } from 'src/components/notifications/notification'
import { textResources } from 'src/lang/de'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'

const labels = textResources.notification

export type ProjectMilestoneNotificationProps = {
  createdAt: string;
  milestoneName: string | null | undefined;
  projectName: string;
} & Pick<
  NotificationProps,
  'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'
>;

const ProjectMilestoneNotification: React.FC<ProjectMilestoneNotificationProps> = ({
  avatarImage,
  createdAt,
  isRead,
  milestoneName,
  onClick,
  projectName
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={projectName}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{labels.notificationNewMilestone}</span>
      {milestoneName && (
        <strong className={clsHighlightedText}>„{milestoneName}“</strong>
      )}
      <span className={clsText}>{labels.notificationCreated}</span>
    </Notification>
  )
}

export default ProjectMilestoneNotification
